<section *ngIf="!isOpened">
  <div class="row">
    <form class="needs-validation container-style" novalidate [formGroup]="formCompany">
      <div class="ps-2 pe-2">
        <div class="row pt-1">
          <div class="col">
            <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
              [width]="'6rem'" [routerLink]="['/', url]" [severity]="null"></app-custom-button>
          </div>
          <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
            @if (isPrincipalCompany && isASADMIN) {
            <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
            }
          </div>

          <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
            @if (isPrincipalCompany && isASADMIN) {
            <app-custom-button class="ms-auto" title="Eliminar compañía" icon="pi pi-trash" severity="contrast"
              (onClick)="openDeleteCompanyModal()">
            </app-custom-button>
            <app-custom-modal #deleteCompany [header]="'Eliminar compañía'" [children]="componentDeleteCompany"
              [width]="'35vw'" [inputs$]="inputsForDeleteCompanyModals$" (params)="reload($event.reload)" hidden>
            </app-custom-modal>
            }

            @if (isPrincipalCompany && isASADMIN) {
            <app-custom-button [title]="'Nuevo Registro'" [label]="'Nuevo'" [severity]="'success'" [variant]="undefined"
              [icon]="'pi pi-plus'" [width]="'5.5rem'" (onClick)="createNewRegister()"></app-custom-button>
            }
          </div>
          <hr class="my-1">
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <app-custom-audit-info [userNameCreate]="companyContract.userNameCreate"
              [createDate]="companyContract.createDate" [userNameUpdate]="companyContract.userNameUpdate"
              [updateDate]="companyContract.updateDate" [reserveSpace]="true"></app-custom-audit-info>
          </div>
        </div>
      </div>
      <div class="row d-flex justify-content-between p-2">
        <div class="col-lg-6">
          <div class="row">
            @if (isASADMIN) {
            <div class="col field-code">
              <app-custom-input-number formControlName="code" [labelText]="'Código'" [required]="true" [recovery]="true"
                (onChangeNumber)="changeCode($event)"></app-custom-input-number>
            </div>
            }
            <div class="col field-alterCode">
              <app-custom-input-text formControlName="alterCode" [labelText]="'Cód. Alterno'"></app-custom-input-text>
            </div>
            @if (isPrincipalCompany && isASADMIN) {
            <div class="col field-deactivationDate">
              <app-custom-datepicker formControlName="deactivationDate"
                [labelText]="'Fecha Desactiv.'"></app-custom-datepicker>
            </div>
            <div class="col state">
              <div class="col field-tag">
                <app-custom-tag [label]="'Estado'" [severity]="severityState" [value]="stateCompany">
                </app-custom-tag>
              </div>
              <div class="col field-button">
                <app-custom-button [title]="titleState" [icon]="icon" [severity]="'primary'"
                  (onClick)="changeStateCompany()">
                </app-custom-button>
              </div>
            </div>
            }
            <div class="col field-name">
              <app-custom-input-text formControlName="name" [labelText]="'Nombre Compañía'" [required]="true">
              </app-custom-input-text>
            </div>
          </div>
          <div class="row">
            <div class="col field-typeDocumentId">
              <app-custom-select formControlName="typeDocumentId" [labelText]="'Tipo Documento'"
                [list]="listTypeDocuments" [required]="true"></app-custom-select>
            </div>
            <div class="col field-document">
              <app-custom-input-text formControlName="document" [labelText]="'Documento'" [required]="true"
                (onChangeTextOnBlur)="getDigitVerification($event)"></app-custom-input-text>
            </div>
            <div class="col field-digitVerification">
              <app-custom-input-text formControlName="digitVerification" [labelText]="'D.Verif.'" [required]="true">
              </app-custom-input-text>
            </div>
          </div>
          <div class="row">
            <div class="col field-typeAccountingSystemId">
              <app-custom-select formControlName="typeAccountingSystemId" [labelText]="'Tipo Interfaz'"
                [list]="listTypeAccountingSystems" [required]="false"
                (onChangeSelect)="changeTypeAccountingSystem($event, null)"></app-custom-select>
            </div>
            <div class="col field-accountingSystemId">
              <app-custom-select formControlName="accountingSystemId" [labelText]="'Sistema'"
                [list]="listAccountingSystem" [required]="formCompany.get('typeAccountingSystemId')?.value !== null"
                (onChangeSelect)="getAccountingSystem($event)"></app-custom-select>
            </div>
          </div>
          @if (formCompany.get('accountingSystemId')?.value === siesaCloud) {
            <div class="row">
              <div class="col field-companySiesaId">
                <app-custom-input-number formControlName="companySiesaId"
                [labelText]="'Compañía Siesa'"></app-custom-input-number>
            </div>
            <div class="col field-systemSiesaId">
              <app-custom-input-number formControlName="systemSiesaId"
                [labelText]="'Sistema Siesa'"></app-custom-input-number>
            </div>
            <div class="col field-conniKeySiesa">
              <app-custom-input-text formControlName="conniKeySiesa" [labelText]="'ConniKey'"
                [maxLength]="50"></app-custom-input-text>
            </div>
            <div class="col field-conniTokenSiesa">
              <app-custom-input-text formControlName="conniTokenSiesa" [labelText]="'ConniToken'"
                [maxLength]="500"></app-custom-input-text>
            </div>
          </div>
          <div class="row">
             <div class="col field-siesaBaseAddress">
               <app-custom-input-text formControlName="siesaBaseAddress" [labelText]="'Url Siesa'"
                [maxLength]="500"></app-custom-input-text>
              </div>
          </div>
          }
        </div>
        <div class="col-lg-5">
          <div class="row">
            <div class="col field-activeUserAmount">
              <app-custom-input-number formControlName="activeUserAmount" [labelText]="'Usuarios Activos'"
                [required]="true"></app-custom-input-number>
            </div>
            <div class="col field-openCutsAmount">
              <app-custom-input-number formControlName="openCutsAmount" [labelText]="'Cortes Abiertos'"
                [required]="true"></app-custom-input-number>
            </div>
            <div class="col field-openCashReceiptsAmount">
              <app-custom-input-number formControlName="openCashReceiptsAmount" [labelText]="'Rec.Caja Abiertos'"
                [required]="true"></app-custom-input-number>
            </div>
            <div class="col field-invoiceExpirationDays">
              <app-custom-input-number formControlName="invoiceExpirationDays" [labelText]="'Días Vencim.Fra.'"
                [required]="true"></app-custom-input-number>
            </div>
            @if (visibleHelissaNiif) {
            <div class="field-checkbox">
              <app-custom-checkbox formControlName="swHelissaNiif" [labelText]="'Helissa Niif'"></app-custom-checkbox>
            </div>
            }
          </div>
          @if (visibleIlimitada) {
          <div class="row">
            <div class="col field-accountingSystemLenght">
              <app-custom-input-number formControlName="accountingSystemLenght" [labelText]="'Long.Ctas.'"
                [required]="true"></app-custom-input-number>
            </div>
            <div class="col field-ilimitadaTypeCree">
              <app-custom-input-text formControlName="ilimitadaTypeCree"
                [labelText]="'Tipo CREE'"></app-custom-input-text>
            </div>
            <div class="col field-creeRate">
              <app-custom-input-text formControlName="creeRate" [labelText]="'Tarifa CREE'">
              </app-custom-input-text>
            </div>
            <div class="field-checkbox">
              <app-custom-checkbox formControlName="swIlimitadaNewPrefix"
                [labelText]="'Nuevo Prefijo'"></app-custom-checkbox>
            </div>
            <div class="field-checkbox">
              <app-custom-checkbox formControlName="swIlimitadaExchangeRate"
                [labelText]="'Tipo Cambio'"></app-custom-checkbox>
            </div>
          </div>
          }
          @if (isASADMIN) {
          <div class="row">
            <div class="col field-buttons">
              <!-- Opciones Avanzadas -->
              <app-custom-button [title]="'Opciones Avanzadas'" [label]="'Opciones Avanzadas'" [width]="'9rem'"
                (onClick)="openAdvancedOptions()">
              </app-custom-button>
              <app-custom-modal #advancedOptions [title]="'Opciones Avanzadas'" [label]="'Opciones Avanzadas'"
                [header]="'Opciones Avanzadas'" [width]="'50vw'" [inputs$]="inputsForAdvancedOptionsModals$"
                [children]="componentAdvancedOptions" hidden>
              </app-custom-modal>
              <!-- Parámetro General -->
              <app-custom-button [title]="'Parámetro General'" [label]="'Parámetro General'" [icon]="'pi pi-cog'"
                [width]="'9.4rem'" [severity]="'success'" (onClick)="openGeneralParameterModal()"></app-custom-button>
              <app-custom-modal #generalParameterModal [label]="'Parámetro General'" [header]="'Parámetro General'"
                [width]="'80vw'" [inputs$]="inputsForGeneralParameterModals$"
                [children]="componentGeneralParameterModal" hidden>
              </app-custom-modal>
              <!-- Permisos -->
              <app-custom-button [title]="'Permisos'" [label]="'Permisos'" [icon]="'pi pi-key'" [width]="'5.5rem'"
                [severity]="'contrast'" (onClick)="openPermissionsCompanyModal()">
              </app-custom-button>
              <app-custom-modal #permissionsCompanyModal [label]="'Permisos'" [header]="'Permisos'" [width]="'60vw'"
                [inputs$]="inputsForPermissionsCompanyModals$" [children]="componentPermissionsCompany" hidden>
              </app-custom-modal>
              <!-- Empresas Mandantes -->
              <app-custom-button [title]="'Empresas Mandantes'" [label]="'Empresas Mandantes'"
                [icon]="'pi pi-building-columns'" [severity]="'contrast'" [width]="'10.5rem'"
                (onClick)="openMandatorModal()">
              </app-custom-button>
              <app-custom-modal #mandatorModal [label]="'Empresas Mandantes'" [header]="'Empresas Mandantes'"
                [width]="'75vw'" [inputs$]="inputsForMandatorModals$" [children]="componentMandator" hidden>
              </app-custom-modal>
            </div>
          </div>
          <div class="row">
            <div class="col field-button-save">
              <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [severity]="'primary'" [variant]="undefined"
                [disabled]="disabledForm" (onClick)="send()">
              </app-custom-button>
            </div>
          </div>
          }
        </div>
      </div>
    </form>
  </div>
</section>
<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>